import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ViewBooking from './ViewBooking';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import { buildBookingListSearch, parseBookingFilters } from '../../../helpers/bookingListFilters';
import messages from '../../../locale/messages';

function action({ store, params, query, intl }) {
    const title = intl.formatMessage(messages.bookingDetails);

    let isAdminAuthenticated = store.getState()?.runtime?.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/bookings/view/', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    const id = Number(params.id);

    return {
        title,
        component: (
            <AdminLayout>
                <ViewBooking
                    title={title}
                    id={id}
                    pageType={'bookings'}
                    listSearch={buildBookingListSearch(parseBookingFilters(query))}
                />
            </AdminLayout>
        )
    }
}

export default action;